import * as React from 'react';

const SortingCenter24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7 7.766a.75.75 0 0 0-.75.748v9.984a.75.75 0 0 0 .75.75h10a.75.75 0 0 0 .75-.75v-4.992a.75.75 0 0 0-.75-.748h-4.25V8.514a.75.75 0 0 0-.75-.748zm4.25 6.49v3.494h-3.5v-3.495h3.5Zm5 3.494h-3.5v-3.495h3.5zm-5-4.992h-3.5V9.262h3.5z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M13.117 1.201a2.75 2.75 0 0 0-2.234 0l-7.25 3.107A2.75 2.75 0 0 0 2 6.817v13.402a2.75 2.75 0 0 0 2.75 2.746h14.5c1.519 0 2.75-1.23 2.75-2.746V6.817c0-1.085-.64-2.069-1.633-2.51zM11.492 2.57a1.25 1.25 0 0 1 1.016 0l7.25 3.106c.451.2.742.647.742 1.14V20.22c0 .69-.56 1.248-1.25 1.248H4.75c-.69 0-1.25-.558-1.25-1.248V6.817c0-.494.29-.94.742-1.14z"
  }
));
SortingCenter24.Size = 24;
SortingCenter24.Title = "SortingCenter";

export { SortingCenter24 as default };
